import * as types from "./MedicineActionTypes";

const initialState = {
  loading: false,
  medicines: [], // Displayed medicines
  allMedicines: [], // Complete unfiltered list
  error: null,
  isSearching: false, // Search state flag
  searchQuery: "", // Current search term
};

const medicineReducer = (state = initialState, action) => {
  switch (action.type) {
    // Loading states
    case types.FETCH_MEDICINES_REQUEST:
    case types.ADD_MEDICINE_REQUEST:
    case types.UPDATE_MEDICINE_REQUEST:
    case types.DELETE_MEDICINE_REQUEST:
    case types.TOGGLE_MEDICINE_STATUS_REQUEST:
    case types.SEARCH_MEDICINES_REQUEST:
      return {...state, loading: true, error: null};

    // Success cases
    case types.FETCH_MEDICINES_SUCCESS:
      return {
        ...state,
        loading: false,
        allMedicines: action.payload,
        medicines: state.isSearching ? state.medicines : action.payload,
        isSearching: state.isSearching, // Maintain search state
      };

    case types.SEARCH_MEDICINES_SUCCESS:
    case types.FILTER_MEDICINES_LOCAL:
      return {
        ...state,
        loading: false,
        medicines: action.payload,
        isSearching: !!action.meta?.query,
        searchQuery: action.meta?.query || "",
      };

    case types.ADD_MEDICINE_SUCCESS:
      const newAllMedicines = [...state.allMedicines, action.payload];
      return {
        ...state,
        loading: false,
        allMedicines: newAllMedicines,
        medicines: state.isSearching ? state.medicines : newAllMedicines,
      };

    case types.UPDATE_MEDICINE_SUCCESS:
      const updatedAllMedicines = state.allMedicines.map((med) =>
        med.id === action.payload.id ? action.payload : med
      );
      return {
        ...state,
        loading: false,
        allMedicines: updatedAllMedicines,
        medicines: state.isSearching
          ? state.medicines.map((med) =>
            med.id === action.payload.id ? action.payload : med
          )
          : updatedAllMedicines,
      };

    case types.DELETE_MEDICINE_SUCCESS:
      const filteredAllMedicines = state.allMedicines.filter(
        (med) => med.id !== action.payload
      );
      return {
        ...state,
        loading: false,
        allMedicines: filteredAllMedicines,
        medicines: state.isSearching
          ? state.medicines.filter((med) => med.id !== action.payload)
          : filteredAllMedicines,
      };

    case types.TOGGLE_MEDICINE_STATUS_SUCCESS:
      const toggledAllMedicines = state.allMedicines.map((med) =>
        med.id === action.payload.id ? action.payload : med
      );
      return {
        ...state,
        loading: false,
        allMedicines: toggledAllMedicines,
        medicines: state.isSearching
          ? state.medicines.map((med) =>
            med.id === action.payload.id ? action.payload : med
          )
          : toggledAllMedicines,
      };

    // Error cases
    case types.FETCH_MEDICINES_FAILURE:
    case types.ADD_MEDICINE_FAILURE:
    case types.UPDATE_MEDICINE_FAILURE:
    case types.DELETE_MEDICINE_FAILURE:
    case types.TOGGLE_MEDICINE_STATUS_FAILURE:
    case types.SEARCH_MEDICINES_FAILURE:
      return {...state, loading: false, error: action.payload};

    default:
      return state;
  }
};

export default medicineReducer;
